const valid=p=>Number.isFinite(p?.latitude)&&Number.isFinite(p?.longitude)&&Math.abs(p.latitude)<=85&&Math.abs(p.longitude)<=180;
const wrap=v=>((v+540)%360)-180;
/** Snap to a real fix only near a recorded point/connected segment, never a gap. */
export function nearestRoutePoint(points,coordinate,maxDistanceMeters=50){
 if(!valid(coordinate)||!Number.isFinite(maxDistanceMeters)||maxDistanceMeters<0)return undefined;
 const factor=Math.cos(coordinate.latitude*Math.PI/180),xy=p=>({x:wrap(p.longitude-coordinate.longitude)*111195*factor,y:(p.latitude-coordinate.latitude)*111195});
 let best=maxDistanceMeters*maxDistanceMeters,chosen;
 for(let i=0;i<points.length;i++){
  if(!valid(points[i]))continue;
  const b=xy(points[i]),db=b.x*b.x+b.y*b.y;
  if(db<=best){best=db;chosen=i;}
  if(!i||!points[i].connectFromPrevious||!valid(points[i-1]))continue;
  const a=xy(points[i-1]),dx=b.x-a.x,dy=b.y-a.y,length=dx*dx+dy*dy,t=length?Math.max(0,Math.min(1,-(a.x*dx+a.y*dy)/length)):0;
  const distance=(a.x+t*dx)**2+(a.y+t*dy)**2;
  if(distance<=best){best=distance;chosen=a.x*a.x+a.y*a.y<=db?i-1:i;}
 }
 return chosen;
}
